import { IActionFn } from '@/store/types';
import { IList, IListRecord, IModuleState, Type } from './types';
import { $file, $http } from '@/axios';
import { downloadFile } from '@/utils/helper';
import store from '@/store';

const map: Record<any, { mutation: string, state: keyof IModuleState }> = {
  [Type.Main]: { mutation: 'setDictMainList', state: 'mainList' },
  [Type.Stop]: { mutation: 'setDictStopList', state: 'stopList' },
  [Type.Synonym]: { mutation: 'setDictSynonymList', state: 'synonymList' },
};

// 查询字典列表
export const queryDicts: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  const mutation = map[payload.type].mutation;
  try {
    const stateKey = map[payload.type].state;
    commit(mutation, { ...(state[stateKey] as IList), loading: true });
    // const res: any = await $http.post('/dict/ext/get', payload);
    const res: any = await $http.post('/v1/baseinfo/dict/list', payload);
    commit(mutation, { data: res.dicts });
  } catch (e) {
    commit(mutation, { data: [] });
  }
};

// 解析搜索分词
export const queryDictSch: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDictSchList', { data: [], loading: true });
    // const res = await $http.post('/dict/check/main/search', payload);
    const res = await $http.post('/v1/baseinfo/dict/analyzer', payload);
    commit('setDictSchList', { data: res });
  } catch (e) {
    commit('setDictSchList', { data: [] });
  }
};

// 解析文档分词(拼音解析)
export const queryDictDoc: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDictDocList', { data: [], loading: true });
    // const res = await $http.post('/dict/check/main/doc', payload);
    const res = await $http.post('/v1/baseinfo/dict/pinyinanalyzer', payload);
    commit('setDictDocList', { data: res });
  } catch (e) {
    commit('setDictDocList', { data: [] });
  }
};

// 检查词语(这里主要用来检查同义词)
export const checkDict: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDictCheckList', { data: [], loading: true });
    commit('setDictSynonymList', { data: [], loading: true });
    // const res: { resultDict: IListRecord[] } = await $http.post('/dict/ext/db/get', payload);
    const res: { resultDict: IListRecord[] } = await $http.post('/v1/baseinfo/dict/dblist', payload);
    commit('setDictCheckList', { data: res.resultDict || [], success: true });
    commit('setDictSynonymList', { data: res.resultDict || [] });
  } catch (e) {
    commit('setDictCheckList', { data: [] });
    commit('setDictSynonymList', { data: [] });
  }
};

// 添加主词典或停止词(接口统一为 update)
export const addDictMain: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/dict/ext/update', payload);
    await $http.post('/v1/baseinfo/dict/update', payload);
    const mutation = map[payload.type].mutation;
    const stateKey = map[payload.type].state;
    const stateList = (state[stateKey] as IList).data;
    const source = [{ source: payload.addDict.source }];
    commit(mutation, { data: [...source, ...stateList].slice(0, 100) });  // 最近100条数据
  } finally {
    commit('setLoading', false);
  }
};

// 添加同义词(接口统一为 update)
export const addDictSynonym: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    // await $http.post('/dict/ext/update', payload);
    await $http.post('/v1/baseinfo/dict/update', payload);
    commit('setDictSynonymList', { data: [payload.addDict, ...state.synonymList.data] });
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 编辑同义词(接口统一为 update)
export const editDictSynonym: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const { index, ...params } = payload;
    commit('setDialog', { ...state.dialog, loading: true });
    // await $http.post('/dict/ext/update', params);
    await $http.post('/v1/baseinfo/dict/update', params);
    state.synonymList.data[payload.index].source = payload.addDict.source;
    commit('setDictSynonymList', { data: [...state.synonymList.data] });
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 删除主词典或停止词(接口统一为 update)
export const deleteDictMain: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/dict/ext/update', payload);
    await $http.post('/v1/baseinfo/dict/update', payload);
    const source = payload.deleteDict.source[0];
    const mutation = map[payload.type].mutation;
    const stateKey = map[payload.type].state;
    const stateList = (state[stateKey] as IList).data;
    const data = stateList.filter((item) => source !== item.source[0]);
    commit(mutation, { data });
  } finally {
    commit('setLoading', false);
  }
};

// 删除同义词(接口统一为 update)
export const deleteDictSynonym: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/dict/ext/update', payload);
    await $http.post('/v1/baseinfo/dict/update', payload);
    const targetStr = payload.deleteDict.target.join(',');
    const data = state.synonymList.data.filter((item) => item.target!.join(',') !== targetStr);
    commit('setDictSynonymList', { data });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 下载字典
export const exportDict: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  // const res: { blob: Blob; filename: string } = await $file.get(`/dict/ext/export/${payload.type}`);
  const res: { blob: Blob; filename: string } = await $file.get(`/v1/baseinfo/dict/${payload.type}/export`);
  const fileNameMap = { [Type.Main]: '主词典', [Type.Stop]: '停止词', [Type.Synonym]: '同义词' } as Record<number, string>;
  downloadFile(res.blob, fileNameMap[payload.type], '.txt');
};

// 上传字典
export const importDict: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  // await $http.post('dict/ext/import', payload);
  await $http.post('/v1/baseinfo/dict/import', payload);
  store.commit('common/setToast', { visible: true, text: '导入成功' });
};
